import { get } from "lodash";
import React, { useCallback, useMemo } from "react";
import { useFormState } from "react-final-form";
import { useSelector } from "react-redux";
import { CustomVariableFormFields } from "../CustomVariableDialog";
import FormulaValue from "../FormulaValue";
import ValueFields from "../ValueFields";
import { getFormulaDisplayValue, getFormulaValueFieldsConfigured, getFormulaValueTimingInfo, CustomVariableValueStatus, } from "store/recipe/custom-variables.utils";
import { currentRecipeCustomVariablesSelector, customVariableRelativeParameterOptionsSelector, customVariableRelativeVariableOptionsSelector, customVariableTransformationOptionsSelector, flatStepsSelector, } from "store/recipe/recipe.selectors";
import { CustomVariableFormulaType } from "store/recipe/recipe.types";
import { processVariablesSelector } from "store/global/global.selectors";
import { getRecipeTimestamps } from "store/recipe/recipe.utils";
const TwoValuesFormulaContent = ({ restrictions }) => {
    const formState = useFormState();
    const customVariables = useSelector(currentRecipeCustomVariablesSelector);
    const processVariables = useSelector(processVariablesSelector);
    const relativeVariableOptions = useSelector(customVariableRelativeVariableOptionsSelector);
    const relativeParameterOptions = useSelector(customVariableRelativeParameterOptionsSelector);
    const transformationOptions = useSelector(customVariableTransformationOptionsSelector);
    const recipeSteps = useSelector(flatStepsSelector);
    const timestampOptions = useMemo(() => getRecipeTimestamps(recipeSteps), [recipeSteps]);
    const titles = useMemo(() => {
        const type = get(formState.values, `${CustomVariableFormFields.formula}.${CustomVariableFormFields.type}`);
        switch (type) {
            case CustomVariableFormulaType.Quotient:
                return ["Numerator", "Denominator"];
            case CustomVariableFormulaType.Power:
                return ["Base", "Power"];
            default:
                return ["First value", "Second Value"];
        }
    }, [formState.values]);
    const getFormulaValue = useCallback((fieldName) => get(formState.values, `${CustomVariableFormFields.formula}.${fieldName}`), [formState.values]);
    const getFormulaValueErrors = useCallback((fieldName) => get(formState.errors, `${CustomVariableFormFields.formula}.${fieldName}`), [formState.errors]);
    const getValueStatus = useCallback((fieldName) => {
        const fieldsConfigured = getFormulaValueFieldsConfigured(getFormulaValue(fieldName));
        const errors = getFormulaValueErrors(fieldName);
        if (errors) {
            return CustomVariableValueStatus.Errored;
        }
        return fieldsConfigured ? CustomVariableValueStatus.Completed : CustomVariableValueStatus.Default;
    }, [getFormulaValue, getFormulaValueErrors]);
    return (React.createElement("div", null,
        React.createElement(FormulaValue, { title: titles[0], defaultOpened: true, value: getFormulaDisplayValue(relativeVariableOptions, relativeParameterOptions, getFormulaValue(CustomVariableFormFields.first)), subtitle: getFormulaValueTimingInfo(getFormulaValue(CustomVariableFormFields.first), timestampOptions, processVariables, transformationOptions, customVariables), status: getValueStatus(CustomVariableFormFields.first) },
            React.createElement(ValueFields, { valueFieldName: CustomVariableFormFields.first, restrictions: restrictions })),
        React.createElement(FormulaValue, { value: getFormulaDisplayValue(relativeVariableOptions, relativeParameterOptions, getFormulaValue(CustomVariableFormFields.second)), title: titles[1], subtitle: getFormulaValueTimingInfo(getFormulaValue(CustomVariableFormFields.second), timestampOptions, processVariables, transformationOptions, customVariables), status: getValueStatus(CustomVariableFormFields.second) },
            React.createElement(ValueFields, { valueFieldName: CustomVariableFormFields.second, restrictions: restrictions }))));
};
export default TwoValuesFormulaContent;
